import { ValueOf } from '@shared/types/common.ts';
import { UserCountryCode, UserCountryCodes } from '@shared/types/countryCodes.ts';

export const GeoTreeNestingModes = {
  FLATTENED_PROVINCES_AND_CITIES: 'flattenedProvincesAndCities',
  DEFAULT_TREE_NESTING: 'defaultTreeNesting',
} as const;

export type GeoTreeNestingMode = ValueOf<typeof GeoTreeNestingModes>;

export const GeoPayloadCollectionModes = {
  SELECTED_NODES_BY_TYPE: 'selectedNodesByType',
  NESTED_CITIES_WITH_PARENT_PROVINCES: 'nestedCitiesWithParentProvinces',
} as const;

export type GeoPayloadCollectionMode = ValueOf<typeof GeoPayloadCollectionModes>;

export type GeoTypeSuffixTranslationKey =
  | 'builder.steps.step02.province'
  | 'builder.steps.step02.city'
  | 'builder.steps.step02.region';

export interface GeoTargetingConfig {
  treeNestingMode: GeoTreeNestingMode;
  showTypeSuffixes: boolean;
  treeLevel2SuffixTranslationKey: GeoTypeSuffixTranslationKey;
  treeLevel3SuffixTranslationKey: GeoTypeSuffixTranslationKey;
  geoPayloadCollectionMode: GeoPayloadCollectionMode;
}

export const DEFAULT_GEO_TARGETING_CONFIG: GeoTargetingConfig = {
  treeNestingMode: GeoTreeNestingModes.FLATTENED_PROVINCES_AND_CITIES,
  showTypeSuffixes: true,
  treeLevel2SuffixTranslationKey: 'builder.steps.step02.province',
  treeLevel3SuffixTranslationKey: 'builder.steps.step02.city',
  geoPayloadCollectionMode: GeoPayloadCollectionModes.SELECTED_NODES_BY_TYPE,
};

export const GERMANY_GEO_TARGETING_CONFIG: GeoTargetingConfig = {
  treeNestingMode: GeoTreeNestingModes.DEFAULT_TREE_NESTING,
  showTypeSuffixes: true,
  treeLevel2SuffixTranslationKey: 'builder.steps.step02.region',
  treeLevel3SuffixTranslationKey: 'builder.steps.step02.city',
  geoPayloadCollectionMode: GeoPayloadCollectionModes.NESTED_CITIES_WITH_PARENT_PROVINCES,
};

const GEO_TARGETING_CONFIG: Record<UserCountryCode, GeoTargetingConfig> = {
  [UserCountryCodes.IT]: DEFAULT_GEO_TARGETING_CONFIG,
  [UserCountryCodes.ES]: DEFAULT_GEO_TARGETING_CONFIG,
  [UserCountryCodes.DE]: GERMANY_GEO_TARGETING_CONFIG,
};

export function getGeoTargetingConfig(country: UserCountryCode): GeoTargetingConfig {
  return GEO_TARGETING_CONFIG[country];
}
